export default __webpack_public_path__ + "static/media/ALLERGEN_EGGS.44d479e9.png";